import {environment} from "./environments/environment";
import {Constants} from "./app/constants";

export const CSP_NONCE_PLACEHOLDER = "__CSP_NONCE__";
export const CSP = "Content-Security-Policy";

const REPORTS_ENDPOINT_NAME = "csp-reports";
export const GLOBAL_HEADERS = new Headers({
  "Strict-Transport-Security": "max-age=63072000; includeSubDomains; preload",
  "X-Frame-Options": "SAMEORIGIN",
  "X-Content-Type-Options": "nosniff",
  "Referrer-Policy": "no-referrer-when-downgrade",
  "Cross-Origin-Opener-Policy": "same-origin",
  "Reporting-Endpoints": `${REPORTS_ENDPOINT_NAME}="/${Constants.Routes.REPORTS}"`,
  "Permissions-Policy": [
    "accelerometer=()",
    "ambient-light-sensor=()",
    "autoplay=()",
    "battery=()",
    "camera=()",
    "cross-origin-isolated=()",
    "display-capture=()",
    "encrypted-media=()",
    "fullscreen=()",
    "geolocation=()",
    "gyroscope=()",
    "keyboard-map=()",
    "magnetometer=()",
    "microphone=()",
    "midi=()",
    "payment=()",
    "picture-in-picture=()",
    "publickey-credentials-get=()",
    "screen-wake-lock=()",
    "sync-xhr=()",
    "usb=()",
    "web-share=()",
    "xr-spatial-tracking=()",
    "clipboard-read=(self)",
    "clipboard-write=(self)",
    "gamepad=()",
    "speaker-selection=()",
    "focus-without-user-activation=()",
    "hid=()",
    "idle-detection=(self)",
    "serial=()",
    "unload=()"
  ].join(",")
});

export const CDN_COOKIEYES = "https://cdn-cookieyes.com";
// Hash of the <style> element in the CookieYes banner markup - changes whenever the banner design is edited in CookieYes
const COOKIEYES_STYLE_HASH = "'sha256-N8QJtx8q0w+iMsSHq3m3Z7KouqkJ/cvDvDcaDEGZuTQ='";
const LOG_COOKIEYES = "https://log.cookieyes.com";
const LEAFLET = "https://tile.openstreetmap.org";
const CONNECT_FACEBOOK = "https://connect.facebook.net";
const FACEBOOK = "https://www.facebook.com";
const APIS_GOOGLE = "https://apis.google.com";
const GOOGLE = "https://*.google.com";
const GOOGLE_APIS = "https://*.googleapis.com";
const GOOGLE_TAG = "https://www.googletagmanager.com";
const GOOGLE_ANALYTICS = "https://*.google-analytics.com";
const GOOGLE_STATS = "https://stats.g.doubleclick.net";
const GOOGLE_PL = "https://www.google.pl";
const FIREBASE = "https://*.firebasedatabase.app";
const FIREBASE_WS = "wss://*.firebasedatabase.app";
const BOOKSY = "https://booksy.com";

const emulatorUrls = environment.firebaseConfig.emulatorUrls.join(" ");
export const contentSecurityPolicy = (path: string, nonce: string) => {
  return [
    "default-src 'self'",
    `img-src 'self' data: ${LEAFLET} ${GOOGLE_APIS} ${GOOGLE} ${GOOGLE_PL} ${FACEBOOK} ${CDN_COOKIEYES} ${emulatorUrls}`,
    `connect-src 'self' ${LOG_COOKIEYES} ${CDN_COOKIEYES} ${GOOGLE_APIS} ${FIREBASE} ${FIREBASE_WS} ${GOOGLE} ${GOOGLE_ANALYTICS} ${GOOGLE_STATS} ${CONNECT_FACEBOOK} ${FACEBOOK} ${emulatorUrls}`,
    "font-src 'self' data:",
    "object-src 'none'",
    "base-uri 'self'",
    `frame-src 'self' ${BOOKSY} ${emulatorUrls}`,
    "frame-ancestors 'none'",
    "style-src-attr 'unsafe-inline'",
    `script-src 'self' 'strict-dynamic' 'nonce-${nonce}' ${GOOGLE_TAG} ${emulatorUrls} ${pathSpecificScriptOrigins(path).join(" ")}`,
    `style-src 'self' 'nonce-${nonce}' ${COOKIEYES_STYLE_HASH}`,
    `trusted-types angular angular#unsafe-bypass firebase-js-sdk-policy default ${pathSpecificTrustedTypes(path).join(" ")}`,
    "require-trusted-types-for 'script'",
    `report-uri /${Constants.Routes.REPORTS}`,
    `report-to ${REPORTS_ENDPOINT_NAME}`
  ].join("; ");
}

export function pathSpecificScriptOrigins(path: string) {
  const globalOrigins = [
    CDN_COOKIEYES,
    CONNECT_FACEBOOK
  ];
  if (path.endsWith(Constants.Routes.DASHBOARD)) {
    return globalOrigins.concat(APIS_GOOGLE);
  }
  return globalOrigins;
}

function pathSpecificTrustedTypes(path: string) {
  if (path.endsWith(Constants.Routes.DASHBOARD)) {
    return ["goog#html", "gapi#gapi"];
  }
  return ["connect.facebook.net/fbevents", "facebook.com/signals/iwl"];
}
